import React, { useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { FaHotel, FaPlane, FaCheckCircle, FaArrowLeft, FaArrowRight, FaUsers, FaChild, FaBaby } from 'react-icons/fa';
import "./devis.css";

export default function Devis({
  places,
  adults,
  children,
  onPlaceSelect,
  setSelectedPlace,
  setTotal,
  total,
  selectedPlace,
  onBack,
  bebe
}) {
  const { t } = useTranslation();

  /* Auto-select the only available accommodation when there's just one
     option, so the user doesn't have to tap a button before continuing. */
  useEffect(() => {
    if (!selectedPlace && Array.isArray(places) && places.length === 1) {
      setSelectedPlace(places[0]);
    }
  }, [places, selectedPlace, setSelectedPlace]);

  useEffect(() => {
    if (selectedPlace) {
      const basePrice = parseInt(selectedPlace.price, 10);
      const childPrice = parseInt(selectedPlace.price_child, 10);
      const roomprice = parseInt(selectedPlace.max_additional, 10);
      setTotal(roomprice + basePrice * adults + childPrice * children);
    }
  }, [selectedPlace, children, setTotal, bebe, adults]);

  return (
    <div className="dv-section">
      <h2 className="dv-title">{t('devis.title')}</h2>
      <p className="dv-subtitle">{t('devis.select_place')}</p>

      {/* Accommodation */}
      <div className="dv-group">
        <div className="dv-group-header">
          <FaHotel className="dv-group-icon" />
          <h3>{t('devis.accommodation.title')}</h3>
        </div>

        <div className="dv-places">
          {places.length > 0 ? (
            places.map((place, index) => {
              const isSelected = selectedPlace === place;
              return (
                <div
                  key={index}
                  className={`dv-place-card ${isSelected ? "selected" : ""}`}
                  onClick={() => setSelectedPlace(place)}
                >
                  {isSelected && <FaCheckCircle className="dv-place-check" />}
                  <h4 className="dv-place-name">{place.name}</h4>
                  <div className="dv-place-details">
                    <div className="dv-place-row">
                      <FaUsers className="dv-place-detail-icon" />
                      <span>{t('devis.accommodation.max_adults')} {place.max_adults}</span>
                    </div>
                    <div className="dv-place-row">
                      <FaChild className="dv-place-detail-icon" />
                      <span>{t('devis.accommodation.max_children')} {place.max_children}</span>
                    </div>
                  </div>
                  <div className="dv-place-pricing">
                    <div className="dv-price-item">
                      <span className="dv-price-label">{t('devis.accommodation.price')}</span>
                      <span className="dv-price-value">{Number(place.price).toLocaleString()} DA</span>
                    </div>
                    <div className="dv-price-item">
                      <span className="dv-price-label">{t('devis.accommodation.price_child')}</span>
                      <span className="dv-price-value">{Number(place.price_child).toLocaleString()} DA</span>
                    </div>
                    <div className="dv-price-item">
                      <span className="dv-price-label">{t('devis.accommodation.price_bebe')}</span>
                      <span className="dv-price-value dv-price-free">{t('devis.accommodation.free')}</span>
                    </div>
                    <div className="dv-price-item">
                      <span className="dv-price-label">{t('devis.accommodation.max_additional')}</span>
                      <span className="dv-price-value">{Number(place.max_additional).toLocaleString()} DA</span>
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="dv-no-places">{t('devis.accommodation.no_places')}</div>
          )}
        </div>
      </div>

      {/* Transport */}
      <div className="dv-group">
        <div className="dv-group-header">
          <FaPlane className="dv-group-icon" />
          <h3>{t('devis.transport.title')}</h3>
        </div>
        <div className="dv-transport-info">
          <span>{t('devis.transport.passengers', { adults, children })}</span>
          <span className="dv-transport-badge">{t('devis.transport.included')}</span>
        </div>
      </div>

      {/* Total */}
      <div className="dv-total-bar">
        <div className="dv-total-label">{t('devis.total.title')}</div>
        <div className="dv-total-value">
          {selectedPlace ? (
            <>{Number(total).toLocaleString()} DA</>
          ) : (
            <span className="dv-total-hint">{t('devis.total.select_accommodation')}</span>
          )}
        </div>
      </div>

      {/* Actions */}
      <div className="dv-actions">
        <button className="dv-btn-back" onClick={onBack}>
          <FaArrowLeft /> {t('devis.buttons.back')}
        </button>
        <button
          className="dv-btn-next"
          onClick={() => selectedPlace && onPlaceSelect(selectedPlace)}
          disabled={!selectedPlace}
        >
          {t('devis.buttons.next')} <FaArrowRight />
        </button>
      </div>
    </div>
  );
}
